
import { Component, Vue } from 'vue-property-decorator';
import GoalPageModel from '../models/GoalPageModel';
import Goal from '@/models/Goal';
import Experience from '@/models/Experience';
import UrlTypeList from '@/models/UriTypeList';
import NEDLogoSvg from '../svg/ned-navigator-logo.svg';
import BadgeSvg from '../svg/badge.svg';
import WaveSmallSvg from '../svg/wave-small.svg';
import ShipSmallSvg from '../svg/ship-small.svg';
import HelmSmallSvg from '../svg/helm-small.svg';
import BoatSmallSvg from '../svg/boat-small.svg';
import BoxDashedSvg from '../svg/box-dashed-color.svg';

@Component({
    components: {
        BadgeSvg,
        NEDLogoSvg,        
        WaveSmallSvg,
        ShipSmallSvg,
        HelmSmallSvg,
        BoatSmallSvg,
        BoxDashedSvg
    }
})
export default class GoalExperienceDetails extends Vue {
    openNedNav() {
        this.$store.commit('setNedWindowIsOpen', !this.$store.getters.getNedWindowIsOpen);
    }

    get step(): number {
        return this.$store.getters.getNedWizardStep;
    }

    get model(): GoalPageModel | null {
        return this.$store.getters.getGoalsInfo;
    }
    
    get isInitializedGoalsInfo(): boolean {
        return this.$store.getters.getInitializedGoalsInfo;
    }    

    get goal(): number {
        return this.$store.getters.getGoal;
    }

    get experience(): number {
        return this.$store.getters.getExperience;
    }
    
    get isInitializedGoal(): boolean {
        return this.$store.getters.getInitializedGoal;
    }
    
    get isInitializedExperience(): boolean {
        return this.$store.getters.getInitializedExperience;
    }

    get currentGoalModel(): Goal | null {
        if (this.$store.getters.getInitializedGoal && this.$store.getters.getInitializedGoalsInfo &&
            this.$store.getters.getGoalsInfo && this.$store.getters.getGoalsInfo.goals) {
            const goalCode = this.$store.getters.getGoal as number;
            const goalsPageModel = this.$store.getters.getGoalsInfo as GoalPageModel;
            const goals = goalsPageModel.goals.filter(x => x.code === goalCode);
            if (goals.length > 0) {
                return goals[0];
            }
        }
        return null;
    }

    get currentExperienceModel(): Experience | null {
        const currentGoal = this.currentGoalModel;
        if (currentGoal && this.$store.getters.getInitializedExperience) {
            const id = this.$store.getters.getExperience as number;
            const exps = currentGoal.experiences.filter(x => x.id === id);
            if (exps.length > 0) {
                return exps[0];
            }
        }
        return null;
    }

    get courses(): UrlTypeList[] {
        if (this.currentExperienceModel && this.currentExperienceModel.coursesList) {
            return this.currentExperienceModel
                .coursesList
                .filter(x => x.type === 'course' || x.type === 'bundle' || x.type === 'more_courses');
        }
        return [];
    }

    get notCourses(): UrlTypeList[] {
        if (this.currentExperienceModel && this.currentExperienceModel.coursesList) {
            return this.currentExperienceModel
                .coursesList
                .filter(x => x.type !== 'course' && x.type !== 'bundle' && x.type !== 'more_courses');
        }
        return [];
    }
}
